import React from 'react';
import Text from '@ingka/text';
import classes from './ContractMix.module.scss';

const ContractMixCard = ({ label, percentage, coworkers } : {
    label: string,
    percentage: string,
    coworkers: string
}) => (
    <div data-testid="contract-mix-card" className={classes['contract-mix__card']}>
        <Text tagName="span" textStyle="Body.M" data-testid="contract-mix-card-label" className={classes['contract-mix__label']}>{label}</Text>
        <div className={classes['contract-mix__values']}>
            <Text tagName="span" textStyle="Body.M" data-testid="contract-mix-percentage" className={classes['contract-mix__percentage']}>{percentage}</Text>
            <Text tagName="span" textStyle="Body.M" data-testid="contract-mix-coworkers" className={classes['contract-mix__coworkers']}>{coworkers}</Text>
        </div>
    </div>
);
export default ContractMixCard;
